import { render } from "./comparison-results.vue?vue&type=template&id=497aa01a&scoped=true"
import script from "./comparison-results.vue?vue&type=script&lang=js"
export * from "./comparison-results.vue?vue&type=script&lang=js"

import "./comparison-results.vue?vue&type=style&index=0&id=497aa01a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1910356388/src/ilongevity-backoffice/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-497aa01a"]])

export default __exports__